import { AlertTypes, Banner, BannerItem, Button } from '@athena/forge';
import BackToLogin from '../common/BackToLogin';
import LogoutLink from '../common/LogoutLink';
import { useCallback } from 'react';
import { getLocalizedString } from '../../utils/i18n-utils';
import PhoneLimitExceededBanner from './PhoneLimitExceededBanner';

interface TerminalViewProps {
  errorMessage: string;
  backToLoginOktaFooterButton?: JQuery;
  alertType: AlertTypes;
}
export default function TerminalView({ errorMessage, backToLoginOktaFooterButton, alertType }: TerminalViewProps) {
  const getLink = useCallback(() => {
    if (errorMessage.includes('error.athena.email.session.token.mismatch')) {
      return <LogoutLink oktaButton={backToLoginOktaFooterButton} />;
    }
    if (errorMessage.includes('accountreset.error')) {
      return <Button
        text={getLocalizedString('accountreset.error.link')}
        variant="tertiary"
        size="small"
        fullWidth={false}
        onClick={() => ({})}
      />;
    }
    return backToLoginOktaFooterButton?.length ? <BackToLogin oktaButton={backToLoginOktaFooterButton} /> : <></>;
  }, [ backToLoginOktaFooterButton, errorMessage ]);

  if (errorMessage.includes('oie.phone.limit.exceeded.error')) {
    return <PhoneLimitExceededBanner />;
  }

  return (
    <Banner alertType={alertType} className="fe_u_padding--small fe_u_text-align--center">
      <BannerItem className="fe_u_padding--bottom-medium">{getLocalizedString(errorMessage.trim()) || errorMessage}</BannerItem>
      {getLink()}
    </Banner>
  );
}
